module.exports = __webpack_public_path__ + "hstl5-e2ae8d0c.webp";